import { Grid, Typography, Box } from "@mui/material";
import CustomBox from "../Common/CustomBox";
import iconsbaggagescan from "../../../../assets/SvgIcons/iconsbaggagescan.svg";
import iconsexitdoor from "../../../../assets/SvgIcons/iconsexitdoor.svg";
import iconsfireextinguisher from "../../../../assets/SvgIcons/iconsfireexitinguisher.svg";
import Card from "../Common/Card";
import FAQ from "../Common/FAQ";
import useCustomLogic from "../../../../Hooks/UseCustomLogic";
import { useState, useEffect } from "react";
import { LoaderComponent } from "../../../../components/Loader/LoaderComponent";
import { BlockGridGraph } from "../BuildingBetterCourtsData";

const cardDataStatic = [
  {
    content: "Baggage Scan",
    img: iconsbaggagescan,
    statistics: "11%",
  },
  {
    content: "Fire Extinguisher",
    img: iconsfireextinguisher,
    statistics: "71%",
  },
  {
    content: "Emergency Exit Sign",
    img: iconsexitdoor,
    statistics: "48%",
  },
];

const faqsStatic = [
  {
    content: "Is there a baggage scanning provision at main entry?",
    status: "No",
  },
  {
    content: "- Does it work?",
    status: "No",
  },
  {
    content: "Is there a baggage scanning provision in the court building?",
    status: "No",
  },
  {
    content: "- Does it work?",
    status: "No",
  },
  {
    content: "Is there a fire extinguisher?",
    status: "Yes",
  },
  {
    content: "Are there emergency exit signs?",
    status: "Yes",
  },
];

export const Security = ({ dataState, dataDistrict, selectedDistrict }) => {
  const { theme, loader } = useCustomLogic();
  let isDistrict = selectedDistrict === "Select District";

  const [cardData, setCardData] = useState(cardDataStatic);
  const [faqs, setFaqs] = useState(faqsStatic);

  const normalizeYesNo = (value) => {
    if (value === null || value === undefined) return "";
    const normalized = String(value).trim().toLowerCase().replace(/_/g, " ");
    if (!normalized) return "";
    if (["yes", "y", "true", "1"].includes(normalized)) return "Yes";
    if (["no", "n", "false", "0"].includes(normalized)) return "No";
    if (normalized === "yes proper") return "Yes Proper";
    if (normalized === "yes not proper") return "Yes Not Proper";
    if (normalized === "not required") return "Not Required";
    return value;
  };

  useEffect(() => {
    if (dataState) {
      let arr = [
        dataState?.baggage_scan ?? 0,
        dataState?.fire_extinguisher ?? 0,
        dataState?.emergency_exit_sign ?? 0,
      ];
      setCardData(
        cardDataStatic.map((item, index) => ({
          ...item,
          statistics: `${arr[index]}%`,
        }))
      );
    }

    if (dataDistrict) {
      let arr = [
        dataDistrict?.baggage_scan_at_main_court ?? dataDistrict?.baggage_scan ?? "",
        dataDistrict?.baggage_scan_working_main_court ??
          dataDistrict?.baggage_scan_working_at_main_court ??
          "",
        dataDistrict?.baggage_scan_at_court_building ??
          dataDistrict?.baggage_scan_at_main_court ??
          "",
        dataDistrict?.baggage_scan_working_at_court_building ??
          dataDistrict?.baggage_scan_working_court_building ??
          dataDistrict?.baggage_scan_working_court_bulding ??
          dataDistrict?.baggage_scan_working_at_main_court ??
          "",
        dataDistrict?.fire_extinguisher_present ??
          dataDistrict?.is_there_fire_extinguisher ??
          dataDistrict?.fire_extinguisher ??
          "",
        dataDistrict?.emergency_exit_signage ??
          dataDistrict?.are_there_emergency_exit_sign ??
          dataDistrict?.emergency_exit_sign ??
          "",
      ];
      setFaqs(faqsStatic.map((item, index) => ({ ...item, status: normalizeYesNo(arr[index]) })));
    }
  }, [dataState, dataDistrict]);

  return (
    <>
      {loader ? (
        <LoaderComponent height="50vh" />
      ) : (
        <Box>
          {isDistrict && (
            <Box>
              <Typography variant="regular3" color="secondary.main">
                Is the court complex secure?
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  mt: "10px",
                  textAlign: "left",
                  letterSpacing: "0.2px",
                  wordSpacing: "1px",
                }}
              >
                Court complexes were studied for the availability of functional baggage scanning
                facility, fire extinguisher and emergency exit signages.
              </Typography>
            </Box>
          )}

          <CustomBox
            content={
              isDistrict ? "AVAILABILITY OF SECURITY MEASURES" : "Is the court complex secure?"
            }
            style={{
              fontSize: !isDistrict && "24px",
              padding: !isDistrict && "8px 13px",
              color: !isDistrict && theme.palette.common.black,
              backgroundColor: !isDistrict && "#e6ebf4",
            }}
          />

          {isDistrict ? (
            <Grid container lg={12} md={12} spacing={2} sx={{ padding: "0 !important" }}>
              {cardData &&
                cardData.map((item, index) => {
                  return (
                    <Grid item xs={12} md={6} lg={6} key={index}>
                      <BlockGridGraph percentage={item?.statistics} color="#F25E5E" />
                      <Card content={item.content} imgSrc={item.img} statistics={item.statistics} />
                    </Grid>
                  );
                })}
            </Grid>
          ) : (
            <Grid item xs={12} sm={12} md={12} lg={12}>
              {faqs &&
                faqs.map((item, index) => (
                  <FAQ
                    content={item.content}
                    status={item.status}
                    isLastItem={index === faqs.length - 1}
                  />
                ))}
            </Grid>
          )}
        </Box>
      )}
    </>
  );
};
